// TODO: rename to chip
import { Chip, ChipProps } from '@mui/material'
import {
  NEW_STATUS_NO,
  EDITED_STATUS_NO,
  SENT_STATUS_NO,
  DELETED_STATUS_NO,
  SEND_ERROR_STATUS_NO,
  CHECKING_1_2_STATUS_NO,
  CHECKING_1_3_STATUS_NO,
  CHECKING_2_3_STATUS_NO,
  VERIFY_STATUS_NO,
  CONFIRMED_STATUS_NO,
  STATUS_LIST,
  StatusNo,
} from 'config'

const COLORS = {
  [NEW_STATUS_NO]: '#72B9D7',
  [DELETED_STATUS_NO]: '#72B9D7',
  [EDITED_STATUS_NO]: '#EDCF69',
  [SENT_STATUS_NO]: '#6BD3A5',
  [SEND_ERROR_STATUS_NO]: '#EB7F5C',
  [CHECKING_1_2_STATUS_NO]: '#EDCF69',
  [CHECKING_1_3_STATUS_NO]: '#EDCF69',
  [CHECKING_2_3_STATUS_NO]: '#EDCF69',
  [VERIFY_STATUS_NO]: '#6BD3A5',
  [CONFIRMED_STATUS_NO]: '#6BD3A5',
} as const

interface Props extends ChipProps {
  status: StatusNo
}

const StatusBadge = ({ status, ...rest }: Props) => {
  return (
    <Chip
      label={STATUS_LIST[status]}
      sx={{
        height: 20,
      }}
      style={{
        fontSize: '.75rem',
        fontWeight: 700,
        backgroundColor: COLORS[status],
        color: 'white',
      }}
      size="small"
      {...rest}
    />
  )
}

export default StatusBadge
